module.exports = __webpack_public_path__ + "/img/SOIC-Custom-Footprint-6tqntb.svg";